module.exports = __webpack_public_path__ + "static/media/4.6_preview.2d0257b0.png";